import api from './api';

const COUNTRY_NAMES = {
  SV: 'El Salvador', GT: 'Guatemala', HN: 'Honduras', MX: 'México',
  CO: 'Colombia', PE: 'Perú', CL: 'Chile', AR: 'Argentina',
  CR: 'Costa Rica', PA: 'Panamá', NI: 'Nicaragua', EC: 'Ecuador',
  BR: 'Brasil', UY: 'Uruguay', PY: 'Paraguay', BO: 'Bolivia', VE: 'Venezuela'
};

const countryManagerService = {
  /**
   * Obtener dashboard del Country Manager
   */
  async getCountryDashboard() {
    const response = await api.get('/partners/dashboard/country');
    return response.data;
  },

  /**
   * Obtener partners del país
   */
  async getCountryPartners() {
    const response = await api.get('/partners/country-partners');
    return response.data;
  },

  /**
   * Generar códigos de prueba
   */
  async generateTrialCodes(quantity = 10) {
    const response = await api.post('/partners/trial-codes/generate', { quantity });
    return response.data;
  },

  /**
   * Obtener estadísticas de códigos de prueba
   */
  async getTrialCodesStats() {
    const response = await api.get('/partners/trial-codes/stats');
    return response.data;
  },

  /**
   * Obtener nombre del país por código ISO
   */
  getCountryName(code) {
    return COUNTRY_NAMES[code] || code;
  }
};

export default countryManagerService;
export { COUNTRY_NAMES };
